export const LOGO_URL =
  "https://customer-assets-lqy194kg.emergentagent.net/job_4245c610-db98-4ce7-9c05-f7e6ad6fe6fc/artifacts/avnqbr7s_No%20background.webp";

export const WHATSAPP_NUMBER = "27665754227";
export const WHATSAPP_DISPLAY = "066 575 4227";
export const CALL_NUMBER = "+27875501154";
export const CALL_DISPLAY = "087 550 1154";
export const SUPPORT_EMAIL = "support@giversdrivenfunds.com";

export const BANKING = {
  account_name: "Givers Driven Funds",
  bank_name: "First National Bank (FNB)",
  account_type: "Current / Cheque Account",
  account_number: "63228282769",
  branch_code: "250655",
  reference_format: "Your initial(s) and surname",
};

export const PACKAGES = [
  {
    id: "basic",
    name: "Basic Package",
    target: "Mainly for school learners",
    min: "R10",
    minValue: 10,
    period: "per month",
    desc: "Start building your financial safety net early with small, affordable monthly contributions.",
    badge: "Entry Level",
    accent: "slate",
  },
  {
    id: "standard",
    name: "Standard Package",
    target: "Mainly for students",
    min: "R200",
    minValue: 200,
    period: "per month",
    desc: "Ideal for tertiary students needing study fees, a laptop, or an allowance backup.",
    badge: "Popular for Youth",
    accent: "blue",
  },
  {
    id: "premium",
    name: "Premium Package",
    target: "Mainly for workers",
    min: "R500",
    minValue: 500,
    period: "per month",
    desc: "Perfect for working individuals needing house upgrades, capital, or bigger help.",
    badge: "Recommended",
    accent: "green",
  },
  {
    id: "pro",
    name: "Pro Account",
    target: "For anyone earning a salary",
    min: "10% of salary",
    minValue: 1000,
    period: "monthly minimum",
    desc: "The highest benefit limit — help scaled to a strong percentage of your monthly income.",
    badge: "Highest Benefit",
    accent: "gold",
  },
];

export const HELP_ITEMS = [
  { icon: "Landmark", title: "Declined bank loans", desc: "Turned away by your bank? We look at what you can do, not just your record." },
  { icon: "ShieldOff", title: "Insurance rejections", desc: "No hidden clauses. When others point to fine print, we point to a solution." },
  { icon: "Home", title: "Build / upgrade your home", desc: "Finance to build, renovate, or upgrade your house or property." },
  { icon: "Briefcase", title: "Start / grow a business", desc: "Capital to start a company or take your existing one to the next level." },
  { icon: "GraduationCap", title: "Studies & school fees", desc: "Cover tuition, registration, and school fees so learning never stops." },
  { icon: "Laptop", title: "Buy a laptop / devices", desc: "Get the tools you need for school, work, or your side hustle." },
  { icon: "HeartPulse", title: "Medical bills", desc: "Help with hospital, treatment, and unexpected medical costs." },
  { icon: "Wallet", title: "Petty cash & more", desc: "No request is too small. What feels small to others is big to us." },
];

export const FAQS = [
  {
    q: "How do I become a member?",
    a: "Register on the website, choose a package (Basic, Standard, Premium or Pro), and start your monthly payments into our FNB account using your unique reference.",
  },
  {
    q: "What is the only rule?",
    a: "You must contribute monthly for at least 6 months before requesting assistance. After that, as long as the community account has a balance, qualified requests get a YES.",
  },
  {
    q: "Can I pay more than the minimum?",
    a: "Yes. The package amounts are minimums. You can pay more at any time. If you pay an amount that qualifies for a higher tier, the system automatically upgrades your package.",
  },
  {
    q: "How do I pay?",
    a: "Pay by EFT or by depositing cash at the bank, then upload your proof of payment. Always use your unique reference (your initials and surname).",
  },
  {
    q: "How much can I be helped with?",
    a: "The higher your package and the more consistently you contribute, the higher the amount you can be assisted with — based on your payment record.",
  },
  {
    q: "Do agents or the owner pay any fees?",
    a: "No. Only members choose and pay for a package. Agents and the owner use the platform for free.",
  },
];
